import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import StepHeader from '../../includes/StepHeader';
import AccountsStore from '../../stores/AccountsStore';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import { HelpMediaComponent } from './HelpMediaComponent';
import { isBOrVMRetail, isVMBusiness } from '../../utils/BrandUtils';
import {
  help,
  spendings,
  interest,
  alerts,
  overdraft,
  projections,
  savingsPot,
  statements,
  sweeps,
} from './AboutBShared';

class AboutB extends Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false, link: 1 };
  }

  componentDidMount() {
    sayLandingMessage(this.props.content.AboutBHead);
  }
  handleOnClick = (event, link) => {
    event.preventDefault();
    this.setState({ showModal: true, link });
  };

  getMediaArray = () => {
    const { content } = this.props;
    if (isBOrVMRetail()) {
      if (AccountsStore.isCreditCardUser()) {
        return [help(content), spendings(content)];
      } else {
        return [
          interest(content, false, this.handleOnClick),
          help(content),
          spendings(content),
          overdraft(content, this.handleOnClick),
          statements(content),
          alerts(content),
          projections(content),
          sweeps(content),
          savingsPot(content),
        ];
      }
    } else {
      if (AccountsStore.isCreditCardUser()) {
        return [help(content)];
      } else if (isVMBusiness()) {
        return [
          interest(content, true, this.handleOnClick),
          help(content),
          statements(content),
          alerts(content),
        ];
      } else {
        return [help(content), statements(content), alerts(content)];
      }
    }
  };

  getModalBody = () => {
    const { content } = this.props;
    return (
      <div>
        <p>{content.HelpPopupContent1}</p>
        <p>{content.HelpPopupContent2}</p>
      </div>
    );
  };

  getModalHeading = () => {
    const { content } = this.props;
    return <strong>{content.PopupHeading}</strong>;
  };

  continue = () => {
    const { content } = this.props;
    this.setState({ showModal: false });

    if (this.state.link === 1) {
      window.open(
        isVMBusiness() ? content.earnInterestLinkSME : content.earnInterestLink
      );
    } else {
      window.open(content.overdraftLink);
    }
  };

  getModalContent = () => {
    const { content } = this.props;
    return (
      <div className="button-group">
        <button
          className="c-btn c-modal__button c-btn--secondary"
          onClick={() => this.setState({ showModal: false })}
        >
          {content.cancelButtonText}
        </button>
        <button
          className="c-btn c-modal__button c-btn--default"
          onClick={this.continue}
        >
          {content.continueButtonText}
        </button>
      </div>
    );
  };

  render() {
    const { content, closed } = this.props;
    // Just for example
    // let accessibilityHeading = `You are on ${content.AboutBHead} Landing Page`;
    // let accessibilityHeading = `${content.aboutBAccessibility1} ${content.AboutBHead} ${content.aboutBAccessibility2}`;
    return (
      <div className="page bow layout layout@xlarge layout--centered about-page-template">
        {/* <span id="accessH1ID" tabIndex="-1" className="u-visually-hidden off-screen" ref="accessibilityHeading" tabIndex="0">{accessibilityHeading}</span> */}
        <div className="layout__inner">
          <div className="container" id="site-main" role="main" tabIndex="-1">
            <div className="row">
              <div className="col-md1-24">
                <article>
                  <StepHeader
                    showheaderCrumbs
                    onClick={closed}
                    headerCrumbsMessage="Back"
                    headerTitle={content.AboutBHead}
                  />
                  <div className="row">
                    <div className="col-md1-24">
                      <HelpMediaComponent mediaList={this.getMediaArray()} />
                      <div>
                        <svg
                          className="timeline-icon"
                          width="20px"
                          height="24px"
                        />
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
        <PatternLibModalComponent
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          bsSize="medium"
          modalHeading={this.getModalHeading()}
          modalBody={this.getModalBody()}
          modalFooter={this.getModalContent()}
          customClass="c-modal"
        />
      </div>
    );
  }
}

AboutB.propTypes = {
  content: PropTypes.shape({}),
  closed: PropTypes.func,
};

AboutB.defaultProps = {
  content: {},
};

export default AboutB;
